// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,*::after,*::before{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
img{
    width: 100%;
    height: 100%;
}
.main{
    width: 600px;
    /* height: 600px; */
    background-color: grey;
    margin: 0 auto;
    display: grid;
    padding: 20px;
    gap: 20px;
}
.top{
    display: flex;
    height: 50px;
    gap: 5px;
}
#img_holder{
    width: 100%;
    height: 400px;
}
#refresh_btn{
    margin-left: auto;
}
button{
    height: 100%;
    width: 50px;
}
#search_box{
    padding-left: 5px;
    outline: none;
    font-size: 1.2rem;
}
#search_box::-webkit-search-cancel-button{
    appearance: none;
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,aAAa;IACb,SAAS;AACb;AACA;IACI,aAAa;IACb,YAAY;IACZ,QAAQ;AACZ;AACA;IACI,WAAW;IACX,aAAa;AACjB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB","sourcesContent":["*,*::after,*::before{\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\nimg{\n    width: 100%;\n    height: 100%;\n}\n.main{\n    width: 600px;\n    /* height: 600px; */\n    background-color: grey;\n    margin: 0 auto;\n    display: grid;\n    padding: 20px;\n    gap: 20px;\n}\n.top{\n    display: flex;\n    height: 50px;\n    gap: 5px;\n}\n#img_holder{\n    width: 100%;\n    height: 400px;\n}\n#refresh_btn{\n    margin-left: auto;\n}\nbutton{\n    height: 100%;\n    width: 50px;\n}\n#search_box{\n    padding-left: 5px;\n    outline: none;\n    font-size: 1.2rem;\n}\n#search_box::-webkit-search-cancel-button{\n    appearance: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
